//app.js frontend

import GlobalStyle from "./styles/GlobalStyle";
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { LoadScript } from "@react-google-maps/api";

import Login from "./pages/Auth";
import Dashboard from "./pages/Dashboard";
import Customers from "./pages/CustomerManagementPage";
//import ServiceOrderForm from "./pages/ServiceOrderForm";
//import TechnicalPendingPage from "./pages/TechnicalPendingPage";
import ProtectedRoute from "./components/ProtectedRoute";
//import OrderDetailsPage from "./pages/OrderDetailsPage";
//import StatusConfigPage from "./pages/StatusConfigPage";
import TeamManagementPage from "./pages/TeamManagementPage";
//import WorkOrderManagement from "./pages/WorkOrderManagement";
import PendenciaManagementPage from "./pages/PendenciaManagementPage";

import PendenciasMobileList from "./pages/PendenciasMobileList";
import PendenciasMobileForm from "./pages/PendenciasMobileForm";

import CustomerMapPage from "./pages/CustomerMapPage";

function App() {
  return (
    <LoadScript
      googleMapsApiKey="AIzaSyDBM41V3dennhdEuAQ-fcnoOZF61hoqdeU"
      libraries={["places"]}
    >
      <Router>
        <GlobalStyle />
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/customer-map"
            element={
              <ProtectedRoute>
                <CustomerMapPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/team-management"
            element={
              <ProtectedRoute>
                <TeamManagementPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/customer-management"
            element={
              <ProtectedRoute>
                <Customers />
              </ProtectedRoute>
            }
          />
          <Route
            path="/pendencias"
            element={
              <ProtectedRoute>
                <PendenciaManagementPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/pendencias-mobile"
            element={
              <ProtectedRoute>
                <PendenciasMobileList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/pendencias-mobile/:id"
            element={
              <ProtectedRoute>
                <PendenciasMobileForm />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </LoadScript>
  );
}

export default App;
